import {
    INIT_GEO_DATASET,
    ADD_DS_GEO,
    CHANGE_DS_GEO,
    DEL_DS_GEO,
    CHANGE_SELROW_GEO,
    CHANGE_NAME_GEO,
    CHANGE_GEO_GEO,
    ADD_GEO_GEO,
    DEL_GEO_GEO,
    ISDEL_GEO,
    RESET_GEO_GEO
} from './actions';

const initData = {
    //プロトタイプ用（13分類）
    dataset: [],
    selRow: null,
    name: '',
    geo: [],
    isDel: false
};

export function geoReducer(state = initData, action) {
    switch (action.type) {
        case INIT_GEO_DATASET:
            return initDsReduce(state, action);
        case ADD_DS_GEO:
            return addDsReduce(state, action);
        case CHANGE_DS_GEO:
            return changeDsReduce(state, action);
        case DEL_DS_GEO:
            return delDsReduce(state, action);
        case CHANGE_SELROW_GEO:
            return changeSelRowReduce(state, action);
        case CHANGE_NAME_GEO:
            return changeNameReduce(state, action);
        case CHANGE_GEO_GEO:
            return changeGeoReduce(state, action);
        case ADD_GEO_GEO:
            return addGeoReduce(state, action);
        case DEL_GEO_GEO:
            return delGeoReduce(state, action);
        case ISDEL_GEO:
            return isDelReduce(state, action);
        case RESET_GEO_GEO:
            return resetGeoReduce(state, action);

        default:
            return state;
    }
}

export function initDsReduce(state, action) {
    return {
        ...state,
        dataset: state.dataset = action.data
    };
}

export function addDsReduce(state, action) {
    return {
        ...state,
        dataset: state.dataset.concat(action.data)
    };
}

export function changeDsReduce(state, action) {
    return {
        ...state,
        dataset: state.dataset.map(el => el.ID === action.data.ID ? action.data : el)
    };
}

export function delDsReduce(state, action) {
    return {
        ...state,
        dataset: state.dataset.filter(el => el.ID - 1 !== action.rowID)
    };
}

export function changeSelRowReduce(state, action) {
    return {
        ...state,
        selRow: action.rowID
    };
}

export function changeNameReduce(state, action) {
    return {
        ...state,
        name: action.name
    };
}

export function changeGeoReduce(state, action) {
    return {
        ...state,
        geo: action.geo
    };
}

export function addGeoReduce(state, action) {
    return {
        ...state,
        geo: state.geo.concat({ ID: action.ID, gID: action.ID, name: '', color: '#ffffff', screen: false })
    };
}

export function delGeoReduce(state, action) {
    return {
        ...state,
        geo: state.geo.filter((el, index) => index !== action.rowID)
    };
}

export function isDelReduce(state, action) {
    return {
        ...state,
        isDel: action.isDel
    };
}

export function resetGeoReduce(state, action) {
    return {
        ...state,
        geo: initData.dataset[0].geo,
        dataset: initData.dataset
    };
}